module.exports = __webpack_public_path__ + "static/Step 3-9fc9a7861c22e398ef44ca565ddf8d2d.png";